import { useMemo } from "react";
import { useGetTalentQuery, useGetTalentsQuery } from "./talentEndpoints";
import { Talent } from "../../entities/talent";

export function useTalent(talentID: number | undefined) {
  const talentQuery = useGetTalentQuery(talentID ?? 0, {
    skip: (talentID ?? 0) <= 0,
  });
  const talentEntity = talentQuery.data;

  return useMemo(() => {
    const ret: typeof talentQuery & { talent?: Talent | undefined } = {
      ...talentQuery,
    };
    if (talentEntity) ret.talent = new Talent(talentEntity);
    return ret;
  }, [talentEntity]);
}

export function useTalents() {
  const talentQuery = useGetTalentsQuery();
  const talentEntitiesMap = talentQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof talentQuery & {
      talents?: Talent[];
      talentsMap?: { [id: number]: Talent };
    } = {
      ...talentQuery,
      talents: [],
      talentsMap: {},
    };
    if (talentEntitiesMap) {
      const talents: Talent[] = [];
      const talentsMap: { [id: number]: Talent } = {};

      for (const key in talentEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(talentEntitiesMap, key)) {
          const c = talentEntitiesMap[key];
          const talent = new Talent(c);
          talents.push(talent);
          talentsMap[talent.id] = talent;
        }
      }
      ret.talents = talents;
      ret.talentsMap = talentsMap;
    }

    return ret;
  }, [talentEntitiesMap]);
}
